<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 24.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 125 30" style="enable-background:new 0 0 125 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#0057A5;}
	.st1{fill:#009BE0;}
</style>
<g>
	<g>
		<path class="st0" d="M15.6,20.4c0.7,0,2.9-0.6,2.9-3.1s-2.5-3.8-5-4c-1-0.1-2.5,0.1-3.4,0.1c-0.8,0-2.4-0.1-4.1-0.9
			c-0.1,0.7-0.2,1.4-0.2,2.1c0,8.1,6.5,14.6,14.6,14.6c1.5,0,2.9-0.2,4.2-0.6l-9.9-8.3C14.7,20.4,14.9,20.4,15.6,20.4z"/>
		<path class="st1" d="M35.1,14.6C35.1,6.5,28.5,0,20.4,0C14.1,0,8.6,4.1,6.6,9.8C3.3,9.7,0.1,6.6,0.1,6.6s2,3.1,6.2,4.1
			c0.8,0.2,1.7,0.3,2.6,0.3c1,0,2.9-0.3,4.7-1.2c1.8-0.8,3.4-1.1,4.4-1.1c2.9,0,4.9,1.1,6,1.9c1.1,0.8,2.4,2,4.5,2
			c2,0,2.4-0.4,2.4-0.4s-0.3-0.7-0.8-0.7s-1.8-0.4-1.8-1.8c0,0,1.4,0.1,2.5,1c1,0.9,1.1,1.7,1.1,1.7s0.6,0,1.2,0.5
			c0.6,0.5,1.5,1.4,1.2,1.6c-0.2,0.2-1.3-0.7-3.2-0.7s-5.5,1.2-6.6,5.3c0,0,0-8.5-9-7.8c0,0,6.5-0.3,6.5,5.1c0,4-3.5,5-4,5
			c0,0,3.2,0.5,5.8,3.4c1.2,1.3,1.8,2.5,2.2,3.4c0.4,1.1,0.4,1.8,0.4,1.8s0.2-0.9,0.2-2.1C31.5,25.6,35.1,20.6,35.1,14.6z"/>
	</g>
	<path class="st0" d="M41.4,6.3c0,0,0,9.6,0,11.7s1.2,3.7,3.3,3.7s4.1-1.1,4.1-1.1L47.5,19c0,0-0.7,0.6-1.5,0.6
		c-0.8,0-1.7-0.4-1.7-2.7c0-2.3,0-5.1,0-5.1h3.3V9.1h-3.2V6.3H41.4z"/>
	<path class="st0" d="M54.6,11.4c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8
		C50.8,13.1,52.5,11.4,54.6,11.4 M54.6,8.7c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6c3.6,0,6.6-2.9,6.6-6.6S58.3,8.7,54.6,8.7
		L54.6,8.7z"/>
	<path class="st1" d="M82.5,10.3c2.7,0,4.9,2.2,4.9,4.9c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9
		C77.5,12.5,79.8,10.3,82.5,10.3 M82.5,8.7c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6c3.6,0,6.6-2.9,6.6-6.6S86.1,8.7,82.5,8.7
		L82.5,8.7z"/>
	<rect x="58.5" y="8.7" class="st0" width="2.7" height="13.1"/>
	<rect x="87.4" y="8.7" class="st1" width="1.6" height="13.1"/>
	<g>
		<polygon class="st0" points="62.4,8.7 66.1,8.7 76.1,21.8 72.2,21.8 		"/>
		<g>
			<polygon class="st1" points="72.6,8.7 70.1,11.9 72,14.4 76.4,8.7 			"/>
			<polygon class="st0" points="67.4,15.4 67,15.9 66.7,16.4 62.6,21.8 66.5,21.8 68.6,19 69,18.5 69.4,18 71.3,15.4 69.4,12.9 			
				"/>
		</g>
	</g>
	<path class="st1" d="M103.8,10.3c2.7,0,4.9,2.2,4.9,4.9c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9
		C98.9,12.5,101.1,10.3,103.8,10.3 M103.8,8.7c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6c3.6,0,6.6-2.9,6.6-6.6S107.5,8.7,103.8,8.7
		L103.8,8.7z"/>
	<path class="st1" d="M118.3,10.3c2.7,0,4.9,2.2,4.9,4.9c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9
		C113.4,12.5,115.6,10.3,118.3,10.3 M118.3,8.7c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6c3.6,0,6.6-2.9,6.6-6.6S121.9,8.7,118.3,8.7
		L118.3,8.7z"/>
	<g>
		<path class="st1" d="M91.4,21.8V8.7H93v2c0.2-0.6,0.6-1.1,1.2-1.5c0.6-0.4,1.9-0.5,2.6-0.5h0.7v1.6h-0.7c-0.9,0-2.3,0.4-3,1.1
			C93.3,12,93,12.8,93,13.8v8H91.4z"/>
	</g>
</g>
</svg>
